import React, { useEffect, useState } from 'react';
import './Menu.css'
import { IoLogOut } from "react-icons/io5";
import {useNavigate } from 'react-router-dom';
import BellAlert from './BellAlert';
import { FcManager } from "react-icons/fc";

export default function TopMenu() {
    const loggedInUser = sessionStorage.getItem("tm_token");
    // const foundUser = JSON.parse(loggedInUser);
    let foundUser = null;

    try {
      foundUser = loggedInUser ? JSON.parse(loggedInUser) : null;
    } catch (err) {
      console.error("Invalid tm_token JSON", err);
      foundUser = null;
    }
    const navigate = useNavigate();
    useEffect(() => {
      if (!foundUser) {
        navigate('/');
      }
    }, [foundUser, navigate]);

    const handleLogout = () => {
      sessionStorage.clear();
      navigate('/');
      window.location.reload();
    }
    // const handleLogout = () => {
    //   sessionStorage.setItem('tm_token', '');
    //   sessionStorage.clear();
    //   navigate('/');
    //   window.location.reload();
    //   return;
    // }
  return (
    <nav className="navbar navibar">
      <div className="container-fluid ">
        <div className="row" style={{ width: '100%' }}>
          <div className="col d-flex justify-content-end align-items-center">
            {/* <HiMiniBellAlert  style={{ fontSize: 25, cursor: 'pointer',marginRight:'40px' }}/> */}
            <BellAlert />
            <h5 style={{marginTop:5}}>Hi {foundUser?.tm_name || 'Guest'}&nbsp;</h5>
            <IoLogOut title='Log Out' style={{ fontSize: 35, cursor: 'pointer' }} onClick={() => { handleLogout() }} />
          </div>
        </div>
      </div>
    </nav>
  )
}
